export type EntityId = number

export type Entity = {
  id: EntityId
  updatedAt?: Date
  createdAt?: Date
}

export type ApiEntity = Pick<Entity, 'id'> & {
  updatedAt?: string
  createdAt?: string
}

export type ApiData<EntityType extends Entity> = {
  [P in keyof Omit<EntityType, 'id'>]: EntityType[P] | ''
}

export enum TemporalEntityId {
  unset = -999,
  delete = -99,
  new = -9,
}
